export default __webpack_public_path__ + "static/media/img6.c6e91b38.png";